import ViewPadrao from "../views/ViewPadrao";
import ContaBancariaList from "../views/ContaBancariaList";
import ContaBancariaCad from "../views/ContaBancariaCad";

export default {
  path: "conta-bancaria",
  component: ViewPadrao,
  children: [
    {
      path: "lista",
      name: "conta-bancaria-list",
      component: ContaBancariaList
    },
    {
      path: "novo",
      name: "conta-bancaria-formulario",
      component: ContaBancariaCad
    },
    {
      path: "editar/:id",
      name: "conta-bancaria-formulario-editar",
      component: ContaBancariaCad
    }
  ]
};
